import { Suspense, useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { Button } from "../../Components/CustomComponents/index.js";
import Table from "../../Components/Table/Table.js";
import styles from "./styles/user_management.module.scss";
// import { ToastContainer, toast } from "react-toastify";
//
import { useDispatch } from "react-redux"; // for getting and setting data into local redux
// import CustomerBlockModal from "../../Components/Modals/CustomerBlockModal";
import _ from "lodash";
import { Col, Row, Spinner } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { FaPlus } from "react-icons/fa6";
import { MdDeleteForever } from "react-icons/md";
import { RiEditFill } from "react-icons/ri";
import SelectFieldComponent from "../../Components/CustomComponents/SelectFieldComponent.js";
import ToolTip from "../../Components/CustomComponents/ToolTip.js";
import DeleteModal from "../../Components/Modals/DeleteModal.js";
import EditPageModal from "../../Components/Modals/EditPageModal.js";
import { useDeletePageMutation } from "../../Data/services/pageApi.js";
import Toast, { SuccessToast } from "../../Hooks/useToast.js";
import Header from "../UserManagement/Components/Header.js";
// import { useDeleteReportTypeMutation } from "../../Data/services/reportTypeApi.js";
import { IoEye } from "react-icons/io5";
import MainCard from "../../Components/Cards/MainCard.js";
import ContentManagementSkeleton from "../../Components/Skeleton/ContentManagementSkeleton.js";

const ContentManagementScreen = ({ setPage }) => {
  const { control, watch } = useForm({
    defaultValues: {
      status: "",
    },
  });

  const status = watch("status");
  const dispatch = useDispatch();

  // const [data, setData] = useState([]);
  const [indicationMessage, setIndicationMessage] = useState("loading...");
  const [rowData, setRowData] = useState([]);
  const [editedData, setEditedData] = useState("");

  const [loading, setLoading] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const [currentPage, setCurrentPage] = useState(1); // todo
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo
  const [dataFetched, setDataFetched] = useState(false); // todo

  const [searchQuery, setSearchQuery] = useState("");

  const filterData = [
    {
      value: "all",
      label: "All Content",
    },
    {
      value: 0,
      label: "Blogs",
    },
    {
      value: 1,
      label: "Posts",
    },
    {
      value: 2,
      label: "Announcements",
    },
  ];

  const [dummyFetch, setDummyFetch] = useState({
    isLoading: true,
    isFetching: true,
  });

  useEffect(() => {
    setTimeout(() => {
      setDummyFetch((prev) => {
        return {
          ...prev,
          isLoading: false,
          isFetching: false,
        };
      });
    }, 2000);
  }, []);

  const dummyData = [
    {
      id: 1,
      title: "How to Choose the Right Real Estate Agent",
      type: "blog",
      status: "published",
      author: "Admin",
      lastModified: "2024-01-15",
      views: 1247,
    },
    {
      id: 2,
      title: "Platform Terms of Service",
      type: "page",
      status: "published",
      author: "Legal Team",
      lastModified: "2024-01-10",
      views: 892,
    },
    {
      id: 3,
      title: "New Agent Verification Process",
      type: "announcement",
      status: "draft",
      author: "Admin",
      lastModified: "2024-01-14",
      views: "-",
    },
  ];

  const handleSearchChange = (event) => {
    const query = event.target.value;
    // console.log("Search query:", query); // You can use this to trigger a search function
    setSearchQuery(query);
  };

  const handleDeleteModalOpen = () => {
    setDeleteModal(true);
  };

  const handleDeleteModalClose = () => {
    setDeleteModal(false);
    setEditedData("");
  };

  const handleEditModalOpen = () => {
    setEditModal(true);
  };

  const handleEditModalClose = () => {
    setEditModal(false);
    setEditedData("");
  };

  const handleAddUser = () => {
    setEditModal(true);
  };

  const [deletePage, { isLoading: isDeleting }] = useDeletePageMutation();

  const deleteData = async (slug) => {
    try {
      const { data } = await deletePage(slug);
      if (data.code === 200) {
        // await refetch();
        handleDeleteModalClose();
        SuccessToast(data.message);
      }
    } catch (error) {
      // console.log(error);
      Toast(error.message, "error");
    }
  };

  function indication() {
    // return something here
    // return 'Table is empty';
    return indicationMessage;
  }

  const columns = [
    {
      dataField: "title",
      text: "Title",
      headerStyle: { width: "250px" },
      style: { whiteSpace: "normal", wordBreak: "break-word" },
    },
    {
      dataField: "type",
      text: "Type",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "140px" },
      formatter: (cellContent) => {
        const badgeClass =
          cellContent === "blog"
            ? "bg-info-subtle text-info"
            : cellContent === "page"
            ? "bg-purple-subtle text-purple"
            : "bg-warning-subtle text-warning fw-bold";

        return (
          <span className={`badge rounded-pill ${badgeClass}`}>
            {cellContent}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "140px" },
      formatter: (cellContent) => {
        const badgeClass =
          cellContent === "published"
            ? "bg-success-subtle text-success fw-bold"
            : "bg-warning text-dark";

        return (
          <span className={`badge rounded-pill ${badgeClass}`}>
            {cellContent}
          </span>
        );
      },
    },
    {
      dataField: "author",
      text: "Author",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "150px" },
    },
    {
      dataField: "lastModified",
      text: "Last Modified",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "160px" },
    },
    {
      dataField: "views",
      text: "Views",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "100px" },
    },
    {
      dataField: "actions",
      text: "Actions",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "200px" },
      formatter: (cellContent, row) => (
        <div className="d-flex justify-content-center align-items-center">
          {/* <ToolTip placement={"top"} content={"View"}>
            <button
              className="btn btn-sm btn-light border rounded-circle"
              onClick={() => alert(`Viewing ${row.title}`)}
            >
              <IoEye size={18} />
            </button>
          </ToolTip> */}
          <ToolTip placement={"top"} content={"Edit"}>
            <button
              className="btn btn-sm btn-primary rounded-circle"
              onClick={() => {
                setEditedData(row);
                handleEditModalOpen();
              }}
            >
              <RiEditFill size={18} />
            </button>
          </ToolTip>
          <ToolTip placement={"top"} content={"Delete"}>
            <button
              className="btn btn-sm btn-danger rounded-circle"
              onClick={() => {
                setEditedData(row);
                handleDeleteModalOpen();
              }}
            >
              <MdDeleteForever size={20} />
            </button>
          </ToolTip>
        </div>
      ),
    },
  ];

  return (
    <div className={styles.MainContainer}>
      {deleteModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <DeleteModal
            handleDeleteModalClose={handleDeleteModalClose}
            data={editedData}
            isDeleting={isDeleting}
            onDelete={deleteData}
          />
        </Suspense>
      ) : (
        ""
      )}

      {editModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <EditPageModal
            handleEditModalClose={handleEditModalClose}
            editData={editedData}
            // refetch={refetch}
          />
        </Suspense>
      ) : (
        ""
      )}

      <div className={styles.headerContainer}>
        <div>
          <Header
            title={"Content Management"}
            subTitle={"Manage website content, blog posts and announcements"}
          />
        </div>

        <Row>
          <Col md={12}>
            <Button
              classes={`${styles.cardBtn} px-3`}
              text={
                <span className="gap-2 d-flex align-items-center">
                  <FaPlus />
                  Create Content
                </span>
              }
              onClick={handleAddUser}
            ></Button>
          </Col>
        </Row>
      </div>

      <br />

      <MainCard>
        {dummyFetch.isLoading ? (
          <ContentManagementSkeleton />
        ) : (
          <>
            <div className="d-flex flex-wrap ">
              <Controller
                control={control}
                name="status"
                render={({ field: { onChange, value } }) => (
                  <span style={{ width: "280px" }}>
                    <SelectFieldComponent
                      firstOption={_.isEmpty(value) ? "Select Type" : value}
                      optionsList={filterData}
                      onSelectChange={onChange}
                    />
                  </span>
                )}
              />
            </div>

            <div
            // className={`${styles.mainTable} ${
            //   dataFetched && isFetching ? "blur-table" : ""
            // }`}
            // className={styles.mainTable}
            >
              {/* {!dataFetched || !isSuccess ? (
          <CustomLoader />
        ) : ( */}
              <div className={styles.mainTable}>
                {
                  <Table
                    data={dummyData || []}
                    columns={columns}
                    indication={indication}
                    totalRecords={totalRecords} // todo
                    totalPages={totalPages} // todo
                    pageSize={pageSize} // todo
                    currentPage={currentPage} // todo
                    setCurrentPage={setCurrentPage} // todo
                    setPageSize={setPageSize} // todo
                    // refetch={refetch} // todo
                    refetch={() => {}} // todo
                  />
                }
              </div>
              {/* )} */}
            </div>
          </>
        )}
      </MainCard>
    </div>
  );
};

export default ContentManagementScreen;
